// =============================================================================
// <Jauge> — barre de progression en scaleX (lot L5, synthèse §5.1 : « jamais
// width, height, top, left » ; audit mouvement u3, M7).
//
// Avant L5, 45 jauges animaient leur `width` : chaque image recalculait la mise
// en page de la ligne. Ici la piste garde sa largeur et le remplissage ne fait
// que s'étirer (transform: scaleX), sur le compositeur, depuis le bord de
// début. 480 ms --ease-out-soft (synthèse M6/M8) ; rien au premier affichage
// (la valeur est posée), fondu sous mouvement réduit (jeton neutralisé en CSS).
//
//   <Jauge valeur={62} />                              sur 100 par défaut
//   <Jauge valeur={3} max={9} couleur={C.teal} hauteur={4} />
//   <Jauge valeur={pct} couleur={col} piste="rgba(255,255,255,.2)" rayon={4}
//          etiquette="Progression du dossier" />
//   <Jauge valeur={fait} max={total} rapide />   progression d'un traitement en
//          cours, mise à jour souvent : 240 ms (--dur-roll) au lieu de 480
//
// Le remplissage n'a PAS de rayon propre (un scaleX l'écraserait) : c'est la
// piste qui arrondit et rogne (overflow hidden). Un repère (seuil de quorum…)
// se pose en enfant : `children` est rendu dans la piste, au-dessus.
// Styles : section « primitives » de src/feuilleGlobale.js (.jauge…).
// =============================================================================

const borne = (x) => (Number.isFinite(x) ? Math.min(1, Math.max(0, x)) : 0);

/** Fraction affichée (0 à 1). Pure, testée. */
export function fractionJauge(valeur, max = 100) {
  const v = Number(valeur);
  const m = Number(max);
  if (!(m > 0)) return 0;
  return borne(v / m);
}

export function Jauge({ valeur = 0, max = 100, couleur = "var(--acc-teal)", piste = "var(--card-inner)",
  hauteur = 8, rayon = 999, etiquette, rapide = false, className = "", style, styleRemplissage, children,
  balise = "div" }) {
  const f = fractionJauge(valeur, max);
  // `balise="span"` : jauge posée dans un contenu phrasé (un <button>, par
  // exemple), où un <div> serait du HTML invalide. Même rendu (bloc).
  const Balise = balise === "span" ? "span" : "div";
  return (
    <Balise className={`jauge${className ? ` ${className}` : ""}`}
      role={etiquette ? "progressbar" : undefined}
      aria-label={etiquette || undefined}
      aria-valuemin={etiquette ? 0 : undefined}
      aria-valuemax={etiquette ? Number(max) || 100 : undefined}
      aria-valuenow={etiquette ? Number(valeur) || 0 : undefined}
      data-rapide={rapide ? "" : undefined}
      style={{ ...(Balise === "span" ? { display: "block" } : null), height: hauteur, borderRadius: rayon, background: piste, ...style }}>
      <Balise className="jauge-plein" style={{ background: couleur, transform: `scaleX(${f.toFixed(4)})`, ...styleRemplissage }} />
      {children}
    </Balise>
  );
}
